import { Check } from 'lucide-react';

interface LoadingOverlayProps {
  visible: boolean;
  message?: string;
  success?: boolean;
  successMessage?: string;
  /** true = fixed full-screen overlay (exports), false = covers parent container (tables) */
  fixed?: boolean;
}

export function LoadingOverlay({
  visible,
  message = 'Loading...',
  success = false,
  successMessage = 'Done',
  fixed = false,
}: LoadingOverlayProps) {
  if (!visible && !success) return null;

  const positionClass = fixed
    ? 'fixed inset-0 z-50 bg-black/25'
    : 'absolute inset-0 z-10 bg-white/60';

  return (
    <div className={`${positionClass} flex items-center justify-center`}>
      <div className="flex items-center gap-3 rounded-md bg-white px-5 py-4 shadow-lg">
        {success ? (
          <div className="relative h-8 w-8">
            <span className="absolute inset-0 rounded-full bg-[#7CB376] opacity-30 animate-ping" />
            <span className="relative flex h-8 w-8 items-center justify-center rounded-full bg-[#7CB376] shadow-sm">
              <Check size={16} color="#FFFFFF" strokeWidth={2} aria-hidden="true" />
            </span>
          </div>
        ) : (
          <div className="h-6 w-6 animate-spin rounded-full border-2 border-[#D0D5DD] border-t-[#404040]" />
        )}
        <span
          style={{
            fontFamily: 'Oxygen',
            fontSize: '14px',
            fontWeight: 400,
            color: '#344054',
          }}
        >
          {success ? successMessage : message}
        </span>
      </div>
    </div>
  );
}

/** Convenience alias for export use case */
export function ExportOverlay({
  isExporting,
  isSuccess,
  loadingMessage = 'Preparing export...',
  successMessage = 'Export complete',
}: {
  isExporting: boolean;
  isSuccess: boolean;
  loadingMessage?: string;
  successMessage?: string;
}) {
  return (
    <LoadingOverlay
      visible={isExporting}
      success={isSuccess}
      message={loadingMessage}
      successMessage={successMessage}
      fixed
    />
  );
}
